"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLogoutFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.8A2.8 2.8 0 0 1 5.8 3h5.4c1.27 0 2.341.844 2.685 2.002a2.993 2.993 0 0 1 1.956.629l.096.08.094.083.09.085 4 4a3 3 0 0 1 .248 3.962l-.08.096-.083.094-.085.09-4 4a2.992 2.992 0 0 1-2.236.877A2.801 2.801 0 0 1 11.2 21H5.8A2.8 2.8 0 0 1 3 18.2V5.8Zm11.707 1.493-.094-.083a1 1 0 0 0-1.32.083l-.083.094a1 1 0 0 0 .083 1.32L15.585 11H7l-.117.007A1 1 0 0 0 7 13h8.585l-2.292 2.293-.083.094a1 1 0 0 0 1.497 1.32l4-4 .083-.094a1 1 0 0 0-.083-1.32l-4-4Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgLogoutFilled);
//# sourceMappingURL=SvgLogoutFilled.js.map